import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toPercentage' })
export class ToPercentagePipe implements PipeTransform {
  public transform(value: number): string {
    if (!value || value > 1) {
      return;
    }

    const percentage = value * 10 * 10;

    return `${percentage % 1 === 0 ? percentage : percentage.toFixed(2)}%`;
  }
}
